import {Button} from "../../../../index";
import React from "react";
import {useViewerStore} from "../../../../../store/store";

const SpinAllModules = () => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const confirmSpinAll = () => {
        sceneViewer.setSpinAllModules();
        sceneViewer.viewerAlert({show: false});
    }

    const cancelSpinAll = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>Are you sure you want to spin all the modules on the roof ? This action will change orientation and
                layout of all roof faces. Click Confirm to proceed.</p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>


                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmSpinAll}
                >
                    Confirm
                </Button>

                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelSpinAll}
                >
                    Cancel
                </Button>
            </div>
        </>
    )
}

export default SpinAllModules;